import { useEffect, useState } from "react";
import { assignNCR, getUsers } from "../../../../services/api/qa/ncrService";
import toast from "react-hot-toast";

export default function NCRAssignModule({ ncrId, refresh }) {

  const [users, setUsers] = useState([]);
  const [assignedTo, setAssignedTo] = useState("");

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      const res = await getUsers();
      console.log("Users for assignment", res);
      setUsers(res);
    } catch {
      toast.error("Failed to load users");
    }
  };

  const handleAssign = async () => {
    if (!assignedTo) {
      toast.error("Select user");
      return;
    }

    try {
      await assignNCR(ncrId, { assigned_to: assignedTo });
      toast.success("NCR Assigned");
      refresh();
    } catch {
      toast.error("Assignment failed");
    }
  };

  return (
    <div className="bg-white shadow rounded p-6">

      <h3 className="font-semibold mb-3">Assign NCR</h3>

      <select
        value={assignedTo}
        onChange={(e) => setAssignedTo(e.target.value)}
        className="border p-2 rounded w-full"
      >
        <option value="">Select User</option>

        {users.map((u) => (
          <option key={u.id} value={u.id}>
            {u.name}
          </option>
        ))}

      </select>

      <button
        onClick={handleAssign}
        className="mt-3 bg-indigo-600 text-white px-4 py-2 rounded"
      >
        Assign
      </button>

    </div>
  );
}